module.exports = __webpack_public_path__ + "img/building-user-solid.e4809bd3.svg";